import { ReactNode, useEffect, useMemo, useState } from 'react';

import { ClientView } from './clients';
import { CourseView } from './course';
import { ProgramView } from './program';
import { setCurrentGroup } from '../reducers/groupSlice';
import { setCurrentProgram, setFirstProgramInGroup } from '../reducers/programSlice';
import { AppDispatch, RootState } from '../reducers/store';
import { useDispatch, useSelector } from 'react-redux';
import { Program } from '../model/program';
import { Group } from '../model/group';
import { Course } from '../model/course';
import { setCurrentCourse } from '../reducers/courseSlice';
import { AlertView } from './alert';
import { supportInfo } from './support';

interface MainProps {
    target: string
}

enum Page {
  CLIENT, 
  PROGRAM,
  MODULE
}

export const MainView = ({target}: MainProps) => {
    const dispatch: AppDispatch = useDispatch();
    
    const groups: Group[] = useSelector((state: RootState) => state.groups.groups);
    
    const programs: Program[] = useSelector((state: RootState) => state.programs.programs);
    const courses: Course[] = useSelector((state: RootState) => state.courses.courses);
    const currentCourse: Course | null = useSelector((state: RootState) => state.courses.currentCourse);

    const errorMessage: string | null = useSelector((state: RootState) => state.error.message);
    
    const [page, setPage] = useState<Page | null>(null);
        
    // target is navigation within the app, here we extract program id
    // target example: `/programs/2b61c7aa-2eb0-420a-9664-01dfe0410799`
    const extractAfterLastDash = (input: string): string => {
        const lastDashIndex = input.lastIndexOf('/');
        if (lastDashIndex === -1) return '';
        return input.substring(lastDashIndex + 1);
    };
    
    const setCurrentProgramAndGroup = (uuid: string): Program | null => {
        for (let program of programs) {
            if (program.id == uuid) {
                dispatch(setCurrentProgram(program))
                
                for (let group of groups) {
                    if (group.displayName == program.clientName) {
                        dispatch(setCurrentGroup(group))
                    }
                }
              return program
            }
        }
        return null;
    }
    
    const setCurrentCourseAndGroup = (uuid: string) => {
        for (let course of courses) {
            if (course.uuid == uuid) {
                dispatch(setCurrentCourse(course))
                
                for (let group of groups) {
                    if (group.displayName == course.role) {
                        dispatch(setCurrentGroup(group))
                    }
                }
            }
        }
    }

    useMemo(() => {
      if (target.startsWith('/clients')) {
        setPage(Page.CLIENT)
      }

      let uuid = extractAfterLastDash(target)
    
      if (/^\/chapters\/[^/]+/.test(target)) {
        setCurrentCourseAndGroup(uuid)
        setPage(Page.MODULE)

      } else if (/^\/programs\/[^/]+/.test(target)) {
        setCurrentProgramAndGroup(uuid)
        setPage(Page.PROGRAM)
      } else if (target.startsWith('/support')) {
        window.location.href = `mailto:${supportInfo.to}?subject=${encodeURIComponent(supportInfo.subject)}`;
      }
    }, [target])

    const selectPage = (page: Page | null): ReactNode => {
      switch(page) {
        case Page.CLIENT:
          return <ClientView/>
        case Page.PROGRAM:
          return <ProgramView/>
        case Page.MODULE:
          return <CourseView course={currentCourse}/>
      }
    }

    return (
      <div style={{ margin: '5rem' }}>
        <AlertView error={errorMessage}/>
        {selectPage(page)}
      </div>
    )

}